import { React, useState, useEffect } from "react";
import { Table, TableCell, TableRow, TextField } from "@mui/material";
import { Button, Alert } from "@mui/material";
import axios from "axios";
import "./ApplyCodes.css";

//NOTE: change if working with different backend branch
// const PORT = "http://127.0.0.1:8000/"
const PORT =
  "http://SkeleChaingang-env.eba-i65amzvv.us-west-2.elasticbeanstalk.com";
// const PORT = "http://femr-central-api.us-west-2.elasticbeanstalk.com/"
/*
This is the component where coders can input their codes 
for the corresponding patient. They can only edit their own
text box and only have view permissions of the other coder's
and the Arbiter's text box. 

Ideally, if the two coders were to disagree on a code,
their textboxes will be highlighted in red, until
the Arbiter makes their decision 
When this happens, the Arbiter either chooses one
of the standard coder's code by clicking on their
textbox, therefore filling the arbiter's box with 
that particular code, and the conflict is resolved 
by both standard coder's text boxes no longer highlighted
in red, but only the chosen coder will be highlighted in green.

If the Arbiter disagrees with both coders, and types their 
own code in a textbox, standard coders are no longer highlighted
in red, but the Arbiter's box will be the one highlighted in green.
*/

//helper for formatting patch request
function codesFromValue(id) {
  //only return element if there is an entry. otherwise, leave as null
  if (document.getElementById(id).value) {
    return {
      codes: document.getElementById(id).value.split(RegExp("[, ]+")),
    };
  } else {
    return null;
  }
}

export const ApplyCodes = () => {
  const [showComponent, setShowComponent] = useState(false);
  const [state, setState] = useState(false);
  const [arbiterIsLoggedIn, setArbiter] = useState(false);
  const [encounter, setEncounter] = useState(); //to be used for renaming buttons

  const [emCoder1Value, setEmCoder1Value] = useState("");
  const [emCoder2Value, setEmCoder2Value] = useState("");
  const [probCoder1Value, setProbCoder1Value] = useState("");
  const [probCoder2Value, setProbCoder2Value] = useState("");
  const [ccCoder1Value, setCcCoder1Value] = useState("");
  const [ccCoder2Value, setCcCoder2Value] = useState("");
  const [covidCoder1Value, setCovidCoder1Value] = useState("");
  const [covidCoder2Value, setCovidCoder2Value] = useState("");

  //Variables if both coder 1 and coder 2 codes are the same:
  const [emValue, setEmValue] = useState("");
  const [probCode, setProbCode] = useState("");
  const [chiefCode, setChiefCode] = useState("");
  const [covidCode, setCovidCode] = useState("");

  useEffect(() => {
    const fetchEncounter = async () => {
      try {
        const response = await axios.get(`${PORT}medical-codes/556/`);
        const userInfo = JSON.parse(localStorage.getItem("userInfo"));
        if (userInfo["roles"][0].name === "Arbiter") {
          //we grab the role of the user logged in
          //if the role of the user in an arbiter, go into arbiter view. otherwise, stay in coder view (false)
          setArbiter(true);
        }

        setEncounter(response.data);

        //Statements to check if coder 1 and coder 2 have the same code.
        //If the codes match, the corresponding textfield will autofill to that code.

        if (
          JSON.stringify(response.data.coder1_office_visit_code.codes) ===
          JSON.stringify(response.data.coder2_office_visit_code.codes)
        ) {
          setEmValue(response.data.coder1_office_visit_code.codes);
          console.log(emValue);
        }

        if (
          JSON.stringify(response.data.coder1_problem_code.codes) ===
          JSON.stringify(response.data.coder2_problem_code.codes)
        ) {
          setProbCode(response.data.coder1_problem_code.codes);
          console.log(probCode);
        }

        if (
          JSON.stringify(response.data.coder1_chief_complaint_code.codes) ===
          JSON.stringify(response.data.coder2_chief_complaint_code.codes)
        ) {
          setChiefCode(response.data.coder1_chief_complaint_code.codes);
          console.log(chiefCode);
        }

        if (
          JSON.stringify(response.data.coder1_covid19_code.codes) ===
          JSON.stringify(response.data.coder2_covid19_code.codes)
        ) {
          setCovidCode(response.data.coder1_covid19_code.codes);
          console.log(covidCode);
        }
      } catch (error) {
        console.warn(error);
        return false;
      }
    };
    fetchEncounter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleButton = async () => {
    //TODO: Arbiter functionality
    if (state) {
      if (arbiterIsLoggedIn) {
        //arbiter patch for undo
        console.log("Undo button is for arbiter pressed.");
        //set all submitted arbiter data (payload from submit button) back to null
        const payload = {
          arbiter_user: null,
          arbiter_office_visit_code: null,
          arbiter_problem_code: null,
          arbiter_chief_complaint_code: null,
          arbiter_covid19_code: null,
          arbiter_submission_date: null,
        };
        try {
          const id = 556; //TODO: replace with CURRENT encounter id
          const result = await axios.patch(
            `${PORT}medical-codes/${id}/`,
            payload
          );
          console.log(result);
        } catch (error) {
          console.error(error);
        }

        setEmCoder1Value("");
        setEmCoder2Value("");
        setProbCoder1Value("");
        setProbCoder2Value("");
        setCcCoder1Value("");
        setCcCoder2Value("");
        setCovidCoder1Value("");
        setCovidCoder2Value("");
      } else {
        console.log("Undo button for coder is pressed.");
        //set all submitted coder data (payload from submit button) back to null
        //TODO: still figure out what coder I am
        const payload = {
          //shouldn't have to set coder name to null
          coder2_office_visit_code: null,
          coder2_problem_code: null,
          coder2_chief_complaint_code: null,
          coder2_covid19_code: null,
          coder2_submission_date: null,
        };
        try {
          const id = 556; //TODO: replace with CURRENT encounter id
          const result = await axios.patch(
            `${PORT}medical-codes/${id}/`,
            payload
          );
          console.log(result);
        } catch (error) {
          console.error(error);
        }

        setEmCoder1Value("");
        setEmCoder2Value("");
        setProbCoder1Value("");
        setProbCoder2Value("");
        setCcCoder1Value("");
        setCcCoder2Value("");
        setCovidCoder1Value("");
        setCovidCoder2Value("");
      }
    } else {
      if (arbiterIsLoggedIn) {
        //arbiter patch for submission
        console.log("Submit button for arbiter is pressed.");
        const currentTime = new Date().toISOString();

        const payload = {
          arbiter_user: 4,
          arbiter_office_visit_code: codesFromValue("EMOfficeVisit"),
          arbiter_problem_code: codesFromValue("problemDX"),
          arbiter_chief_complaint_code: codesFromValue("chiefComplaint"),
          arbiter_covid19_code: codesFromValue("covid19Testing"),
          arbiter_submission_date: currentTime,
        };

        try {
          const id = 556; //TODO: replace with CURRENT encounter id
          //console.log(`patch request to ${PORT}medical-codes/${id}`)
          const result = await axios.patch(
            `${PORT}medical-codes/${id}/`,
            payload
          );
          console.log(result);
        } catch (error) {
          console.error(error);
        }
      } else {
        console.log("Submit button for coder is pressed.");
        const currentTime = new Date().toISOString();
        //TODO: figure out what coder I am
        //TODO: "coder${coder}_submission_date" field in the view or here
        // "coder1_user" field should be updated as soon as a coder opens the patient encounter, not after submitting a code
        const payload = {
          coder2_user: 3,
          coder2_office_visit_code: codesFromValue("EMOfficeVisit"),
          coder2_problem_code: codesFromValue("problemDX"),
          coder2_chief_complaint_code: codesFromValue("chiefComplaint"),
          coder2_covid19_code: codesFromValue("covid19Testing"),
          coder2_submission_date: currentTime,
        };

        try {
          const id = 556; //TODO: replace with CURRENT encounter id
          //console.log(`patch request to ${PORT}medical-codes/${id}`)
          const result = await axios.patch(
            `${PORT}medical-codes/${id}/`,
            payload
          );
          console.log(result);
        } catch (error) {
          console.error(error);
        }
      }
    }

    setShowComponent(!showComponent);
    setState(!state);
  };

  return (
    <div>
      <Table className="table-container">
        <h1 style={{ fontSize: "15px" }}>CPT Codes/HCPCS</h1>
        <TableRow className="row-style">
          <TableCell variant="head">E/M Office Visit</TableCell>
          <TextField
            id="EMOfficeVisit"
            size="medium"
            value={emValue || emCoder1Value || emCoder2Value}
            onChange={(e) => {
              if (emCoder1Value) {
                setEmCoder1Value(e.target.value);
              } else {
                setEmCoder2Value(e.target.value);
              }
            }}
          />
          {arbiterIsLoggedIn && (
            <>
              <p>
                Coder 1:
                {!(
                  encounter.coder1_office_visit_code &&
                  encounter.coder1_office_visit_code.codes
                ) && <p>No Codes Provided</p>}
                <Button
                  onClick={() => {
                    if (
                      encounter.coder1_office_visit_code &&
                      encounter.coder1_office_visit_code.codes
                    ) {
                      setEmCoder1Value(
                        encounter.coder1_office_visit_code.codes
                      );
                    } else {
                      setEmCoder1Value("");
                    }
                    setEmCoder2Value("");
                  }}
                >
                  {encounter.coder1_office_visit_code &&
                  encounter.coder1_office_visit_code.codes
                    ? encounter.coder1_office_visit_code.codes
                    : ""}
                </Button>
              </p>
              <p>
                Coder 2:
                {!(
                  encounter.coder2_office_visit_code &&
                  encounter.coder2_office_visit_code.codes
                ) && <p>No Codes Provided</p>}
                <Button
                  onClick={() => {
                    if (
                      encounter.coder2_office_visit_code &&
                      encounter.coder2_office_visit_code.codes
                    ) {
                      setEmCoder2Value(
                        encounter.coder2_office_visit_code.codes
                      );
                    } else {
                      setEmCoder2Value("");
                    }
                    setEmCoder1Value("");
                  }}
                >
                  {encounter.coder2_office_visit_code &&
                  encounter.coder2_office_visit_code.codes
                    ? encounter.coder2_office_visit_code.codes
                    : ""}
                </Button>
              </p>
            </>
          )}
        </TableRow>

        <h1 style={{ fontSize: "15px" }}>ICD-10-CM</h1>
        <TableRow className="row-style">
          <TableCell variant="head">Problem/ DX</TableCell>
          <TextField
            id="problemDX"
            size="medium"
            value={probCode || probCoder1Value || probCoder2Value}
            onChange={(e) => {
              if (probCoder1Value) {
                setProbCoder1Value(e.target.value);
              } else {
                setProbCoder2Value(e.target.value);
              }
            }}
          />

          {arbiterIsLoggedIn && (
            <>
              <p>
                Coder 1:
                {!(
                  encounter.coder1_problem_code &&
                  encounter.coder1_problem_code.codes
                ) && <p>No Codes Provided</p>}
                <Button
                  onClick={() => {
                    if (
                      encounter.coder1_problem_code &&
                      encounter.coder1_problem_code.codes
                    ) {
                      setProbCoder1Value(encounter.coder1_problem_code.codes);
                    } else {
                      setProbCoder1Value("");
                    }
                    setProbCoder2Value("");
                  }}
                >
                  {encounter.coder1_problem_code &&
                  encounter.coder1_problem_code.codes
                    ? encounter.coder1_problem_code.codes
                    : ""}
                </Button>
              </p>
              <p>
                Coder 2:
                {!(
                  encounter.coder2_problem_code &&
                  encounter.coder2_problem_code.codes
                ) && <p>No Codes Provided</p>}
                <Button
                  onClick={() => {
                    if (
                      encounter.coder2_problem_code &&
                      encounter.coder2_problem_code.codes
                    ) {
                      setProbCoder2Value(encounter.coder2_problem_code.codes);
                    } else {
                      setProbCoder2Value("");
                    }
                    setProbCoder1Value("");
                  }}
                >
                  {encounter.coder2_problem_code &&
                  encounter.coder2_problem_code.codes
                    ? encounter.coder2_problem_code.codes
                    : ""}
                </Button>
              </p>
            </>
          )}
        </TableRow>

        <TableRow className="row-style">
          <TableCell variant="head">Chief Complaint</TableCell>
          <TextField
            id="chiefComplaint"
            size="medium"
            value={chiefCode || ccCoder1Value || ccCoder2Value}
            onChange={(e) => {
              if (ccCoder1Value) {
                setCcCoder1Value(e.target.value);
              } else {
                setCcCoder2Value(e.target.value);
              }
            }}
          />
          {arbiterIsLoggedIn && (
            <>
              <p>
                Coder 1:
                {!(
                  encounter.coder1_chief_complaint_code &&
                  encounter.coder1_chief_complaint_code.codes
                ) && <p>No Codes Provided</p>}
                <Button
                  onClick={() => {
                    if (
                      encounter.coder1_chief_complaint_code &&
                      encounter.coder1_chief_complaint_code.codes
                    ) {
                      setCcCoder1Value(
                        encounter.coder1_chief_complaint_code.codes
                      );
                    } else {
                      setCcCoder1Value("");
                    }
                    setCcCoder2Value("");
                  }}
                >
                  {encounter.coder1_chief_complaint_code &&
                  encounter.coder1_chief_complaint_code.codes
                    ? encounter.coder1_chief_complaint_code.codes
                    : ""}
                </Button>
              </p>
              <p>
                Coder 2:
                {!(
                  encounter.coder2_chief_complaint_code &&
                  encounter.coder2_chief_complaint_code.codes
                ) && <p>No Codes Provided</p>}
                <Button
                  onClick={() => {
                    if (
                      encounter.coder2_chief_complaint_code &&
                      encounter.coder2_chief_complaint_code.codes
                    ) {
                      setCcCoder2Value(
                        encounter.coder2_chief_complaint_code.codes
                      );
                    } else {
                      setCcCoder2Value("");
                    }
                    setCcCoder1Value("");
                  }}
                >
                  {encounter.coder2_chief_complaint_code &&
                  encounter.coder2_chief_complaint_code.codes
                    ? encounter.coder2_chief_complaint_code.codes
                    : ""}
                </Button>
              </p>
            </>
          )}
        </TableRow>

        <h1 style={{ fontSize: "15px" }}>COVID-19</h1>
        <TableRow className="row-style">
          <TableCell variant="head">Covid-19 Testing</TableCell>
          <TextField
            id="covid19Testing"
            size="medium"
            value={covidCode || covidCoder1Value || covidCoder2Value}
            onChange={(e) => {
              if (covidCoder1Value) {
                setCovidCoder1Value(e.target.value);
              } else {
                setCovidCoder2Value(e.target.value);
              }
            }}
          />

          {arbiterIsLoggedIn && (
            <>
              <p>
                Coder 1:
                {!(
                  encounter.coder1_covid19_code &&
                  encounter.coder1_covid19_code.codes
                ) && <p>No Codes Provided</p>}
                <Button
                  onClick={() => {
                    if (
                      encounter.coder1_covid19_code &&
                      encounter.coder1_covid19_code.codes
                    ) {
                      setCovidCoder1Value(encounter.coder1_covid19_code.codes);
                    } else {
                      setCovidCoder1Value("");
                    }
                    setCovidCoder2Value("");
                  }}
                >
                  {encounter.coder1_covid19_code &&
                  encounter.coder1_covid19_code.codes
                    ? encounter.coder1_covid19_code.codes
                    : ""}
                </Button>
              </p>
              <p>
                Coder 2:
                {!(
                  encounter.coder2_covid19_code &&
                  encounter.coder2_covid19_code.codes
                ) && <p>No Codes Provided</p>}
                <Button
                  onClick={() => {
                    if (
                      encounter.coder2_covid19_code &&
                      encounter.coder2_covid19_code.codes
                    ) {
                      setCovidCoder2Value(encounter.coder2_covid19_code.codes);
                    } else {
                      setCovidCoder2Value("");
                    }
                    setCovidCoder1Value("");
                  }}
                >
                  {encounter.coder2_covid19_code &&
                  encounter.coder2_covid19_code.codes
                    ? encounter.coder2_covid19_code.codes
                    : ""}
                </Button>
              </p>
            </>
          )}
        </TableRow>
      </Table>

      <div className="button_design">
        {" "}
        <Button onClick={handleButton}> {state ? "Undo" : "Submit"} </Button>
        {showComponent && (
          <Alert severity="success"> Your codes have been submitted! </Alert>
        )}
      </div>
    </div>
  );
};

export default ApplyCodes;
